<mat-card appearance="outlined" class="card">
  <mat-card-header>
    <mat-card-title>
      <h4 class="card-title">
        {{data.title}}
      </h4>
    </mat-card-title>
  </mat-card-header>
  <div *ngIf="!wait" class="tac margin-top">
    {{data.QRDescription}}</div>
  <mat-card-content>
    <div class="qr-container tar">
      <qrcode *ngIf="!wait" class="qr-content" [matTooltip]="data?.QDescription" [qrdata]="qrString" [size]="'220'" [level]="'H'"
        [usesvg]="false">
      </qrcode>
      <mat-progress-bar mode="indeterminate" *ngIf="wait" class="qr-content"></mat-progress-bar>
    </div>
    <div class="qr-timer">{{data.timeoutTxt}} - {{timeLeft}}</div>
  </mat-card-content>
  <mat-card-actions class="tar">
    <button mat-raised-button mat-dialog-close (click)="close(false)" [disabled]="wait">{{data.cancelTxt}}</button>
  </mat-card-actions>
</mat-card>